const SvgHelper = async (name) => {
  const url = `svg/${name}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    var svgData = await response.text();
    svgData = svgData.replace("stroke-width: .2px","stroke-width: 1.5px");

    // debugger;

    return svgData;
  } catch (error) {
    throw new Error(error.message);
  }
};

const initPattern = function() {
  const groups = document.querySelectorAll("#svg-container g");

  // Loops though all the polygons and index them for repeat design
  groups.forEach(group => {
    let polygons = group.querySelectorAll("polygon");

    polygons.forEach((polygon, i) => {

      polygon.setAttribute("data-index",i);

      if(polygon.getAttribute("data-rotation") !== null) return false;
      var points = polygon.getAttribute("points").split(" ");
       if(points[0] === points[2]){
        polygon.setAttribute("data-rotation","vertical");
       }
       else{
        polygon.setAttribute("data-rotation","horizontal");
       }
    })
  })
}

const AddFillPattern = function (product) {


  // Get different rotations in pattern
  const rotationsArray = [];
  document.querySelectorAll('#svg-container polygon').forEach(p => {
    p.getAttribute("data-rotation").split(",").forEach(rotation => {
      if(!rotationsArray.includes(rotation)) rotationsArray.push(rotation);
    })

  })


  //if(document.querySelectorAll(`#svg-container pattern[id*='${product.id}']`).length > 0) return false;

  // Looping add three differnt product image variations using the pick= attribute in the render request
  for (let i = 0; i < 20; i++) {

    let patternsHtml = document.querySelector("#svg-container defs").innerHTML;

    let imgSize = 256;

    let imgRotations = {
      //  ang_0 : `https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${200}`,
       ang_0 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=0&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_60 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=60&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_120 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=120&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_90 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=90&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_135 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=135&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_45 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=45&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_180 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=180&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
       ang_270 : `https://tarkettcontourstaging.chameleonpower.com/services/imgproxy.ashx?angle=270&imageUrl=${encodeURIComponent(`https://renderfarm1.chameleonpower.com/cham/getImage.ashx?sel=${product.id}&type=samp&pick=${i}&size=${imgSize}`)}`,
    }

    let newPatterns = "";

    rotationsArray.forEach(rotation => {
      newPatterns += `
        <pattern id="product-${product.id}-${rotation}-${i}" height="1" width="1" patternContentUnits="objectBoundingBox">
          <image height="1" width="1" preserveAspectRatio="none" xlink:href="${imgRotations[rotation]}" onerror="this.href.baseVal='${imgRotations[rotation]}'">
              </image>
        </pattern>
      `;


    })


    document.querySelector("#svg-container defs").innerHTML = patternsHtml + newPatterns;
  }
};




const getRandomNumber = function(min=0, max=19) {
  let random = Math.floor(Math.random() * (max - min + 1)) + min;
  return random;
}

const FloodFill = function (product, callback) {

  if (!product || !product.size) {
    console.error("FloodFill error: product or product.size is undefined", product);
    return;
  }

  const polygons = document.querySelectorAll("#svg-container polygon");

  polygons.forEach((polygon) => {
    var rotationArr = polygon.getAttribute("data-rotation").split(",");
    var randomRotation = getRandomNumber(0,rotationArr.length-1);

    // console.log("rotations", rotationArr, randomRotation);

    var variation = getRandomNumber();
    var size = polygon.getAttribute("data-name").split(" ")[1]

    if(product.size !== size){
      console.log(product)
      console.log('SIZE ERROR')
        console.log('product.size',product.size)
        console.log('size',size)
       return false;
    }

    polygon.setAttribute("fill", `url(#product-${product.id}-${rotationArr[randomRotation]}-${variation})`);
  });

  AddFillPattern(product);


  callback();

};

const FreeDesign = function (element, product, callback) {

  // var rotation = element.getAttribute("data-rotation");
  var variation = getRandomNumber();
  var size = element.getAttribute("data-name").split(" ")[1]

  var rotationArr = element.getAttribute("data-rotation").split(",");
  var randomRotation = getRandomNumber(0,rotationArr.length-1);

  if(product.size !== size){
    alert("Selected product size does not match the tile size for this placement. Please select a Product with size "+size);
    return false;
  } 
  element.setAttribute("fill", `url(#product-${product.id}-${rotationArr[randomRotation]}-${variation})`);

  AddFillPattern(product);

  callback();
};

const repeatDesign = function (element, product, callback) {

  const repeatIndex = element.getAttribute("data-index");
  const polygons = document.querySelectorAll(`#svg-container polygon[data-index='${repeatIndex}']`);

  var size = polygons[0].getAttribute("data-name").split(" ")[1]

  if(product.size !== size){
    alert("Selected product size does not match the tile size for this placement. Please select a Product with size "+size);
    return false;
  } 

  polygons.forEach((polygon) => {
    // var rotation = polygon.getAttribute("data-rotation");
    var variation = getRandomNumber();

    var rotationArr = polygon.getAttribute("data-rotation").split(",");
    var randomRotation = getRandomNumber(0,rotationArr.length-1);


    polygon.setAttribute("fill", `url(#product-${product.id}-${rotationArr[randomRotation]}-${variation})`);
  });

  AddFillPattern(product);

  callback();
};

const randomizeDesign = function(tileSelection, callback) {
  var tiles = [];

  console.log(tileSelection);


  for(const key in tileSelection){
    AddFillPattern({id:key});
    tiles.push(tileSelection[key]);
  }


  const polygons = document.querySelectorAll("#svg-container polygon");

  // Reset all polygons first
  polygons.forEach(p => {
    p.setAttribute("fill", `#fff`);
  })


  let counter = 0;


  while(document.querySelectorAll(`#svg-container polygon[fill='#fff']`).length !== 0 && counter < 10000){
    var randomProduct = tiles[getRandomNumber(0, tiles.length-1)];

    var randomPcnt = (document.querySelectorAll(`#svg-container polygon[fill*='${randomProduct.id}']`).length*100/polygons.length).toFixed(0);


    let randomPoly = getRandomNumber(0, document.querySelectorAll(`#svg-container polygon[fill='#fff']`).length-1);

    // let p = document.querySelector(`#svg-container polygon[fill='#fff']`);

    let p = document.querySelectorAll(`#svg-container polygon[fill='#fff']`)[randomPoly];

    


    if(parseInt(randomProduct.percentage) > parseInt(randomPcnt) && p !== null){

      // var rotation = p.getAttribute("data-rotation");
      var variation = getRandomNumber();

      var rotationArr = p.getAttribute("data-rotation").split(",");
      var randomRotation = getRandomNumber(0,rotationArr.length-1);

      p.setAttribute("fill", `url(#product-${randomProduct.id}-${rotationArr[randomRotation]}-${variation})`);
    }

   console.log(counter);

    counter ++;

  }



  callback();
}

const resetPattern = function() {
  const polygons = document.querySelectorAll("#svg-container polygon");

  polygons.forEach((polygon) => {
    polygon.removeAttribute("fill");
  });

}

const replaceProduct = function(currentProd, newProd) {

  const polygons = document.querySelectorAll(`#svg-container polygon[fill*='${currentProd}']`);
  const patterns = document.querySelectorAll(`#svg-container pattern[id*='${currentProd}']`);

  patterns.forEach(pattern => {
    pattern.remove();
  })

  AddFillPattern({id:newProd.id});

  polygons.forEach(polygon => {
    let newFill = polygon.getAttribute("fill").replace(currentProd,newProd.id);
    polygon.setAttribute("fill",newFill);
  })
}

const removeTile = function(productId) {
  const polygons = document.querySelectorAll(`#svg-container polygon[fill*='${productId}']`);
  const patterns = document.querySelectorAll(`#svg-container pattern[id*='${productId}']`);

  // Remove patterns
  patterns.forEach(pattern => {
    pattern.remove();
  })

  // reset polygon fill
  polygons.forEach(polygon => {
    polygon.removeAttribute("fill");
  })
}


const rotateBase64Image = function (base64Image, degrees) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set canvas dimensions based on rotation
      if (degrees % 180 === 0) {
        canvas.width = img.width;
        canvas.height = img.height;
      } else {
        canvas.width = img.height;
        canvas.height = img.width;
      }

      // Translate and rotate the canvas
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(degrees * Math.PI / 180);

      // Draw the image
      ctx.drawImage(img, -img.width / 2, -img.height / 2);

      // Get the rotated image as Base64
      const rotatedBase64 = canvas.toDataURL();
      resolve(rotatedBase64);
    };
    img.onerror = reject;
    img.src = base64Image;
  });
}


function svgElementToBase64(svgElement) {
  if (!(svgElement instanceof SVGElement)) {
    throw new Error("Input must be an SVGElement");
  }

  // Serialize the SVG DOM element to a string
  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(svgElement);

  // Optional: remove line breaks and trim whitespace
  const cleaned = svgString.replace(/\n/g, '').replace(/\s+/g, ' ').trim();

  // Encode to Base64 (handle UTF-8 properly)
  const utf8Encoded = encodeURIComponent(cleaned)
    .replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16))
    );

  const base64 = btoa(utf8Encoded);

  // Return data URI
  return `data:image/svg+xml;base64,${base64}`;
}


function removeUnusedPatternsFromClone(svgElement) {
  // Deep clone the SVG element
  const clonedSvg = svgElement.cloneNode(true);

  // Collect all used pattern ids from polygon fill attributes
  const usedPatternIds = new Set();
  const polygons = clonedSvg.querySelectorAll("polygon[fill^='url(#']");
  polygons.forEach(polygon => {
    const fill = polygon.getAttribute("fill");
    const match = fill.match(/^url\(#(.+)\)$/);
    if (match) {
      usedPatternIds.add(match[1]);
    }
  });

  // Select all pattern elements inside <defs>
  const patterns = clonedSvg.querySelectorAll("defs pattern");
  patterns.forEach(pattern => {
    if (!usedPatternIds.has(pattern.id)) {
      pattern.remove();
    }
  });

  return clonedSvg;
}

export { SvgHelper, FloodFill, AddFillPattern, FreeDesign, repeatDesign, 
  initPattern, resetPattern, replaceProduct, removeTile, randomizeDesign, rotateBase64Image, svgElementToBase64, removeUnusedPatternsFromClone }; // Default export
